import type React from "react"
import { cn } from "../../lib/utils"

interface PageActionsBarProps {
	/** Shifts the strip left of the open 360px members-chat rail. */
	chatRailOpen?: boolean
	className?: string
	children: React.ReactNode
}

/**
 * The contextual page-action cluster (chat toggle / Share / Manage) pinned
 * to the viewport's top-right corner, vertically aligned with the rail's
 * 56px logo row — above the page content, which clears it via the
 * PageContainer top rhythm. Desktop only; mobile keeps the actions in the
 * fixed mobile bar. Sits below the chat rail and the notifications drawer
 * (z-30) and the rail (z-40). The 34px right padding centers the 36px
 * Manage trigger on the Mareczek FAB line (right-6 + w-14/2 = 52px).
 */
export function PageActionsBar({
	chatRailOpen,
	className,
	children,
}: PageActionsBarProps) {
	return (
		<div
			className={cn(
				"fixed top-0 z-20 hidden h-14 items-center gap-3 pr-[34px] md:flex",
				chatRailOpen ? "md:right-[360px]" : "right-0",
				className,
			)}
		>
			{children}
		</div>
	)
}
